export default __webpack_public_path__ + "static/media/map.f15f2ad0.png";